import { render, staticRenderFns } from "./editServer.vue?vue&type=template&id=493beb98&scoped=true&"
import script from "./editServer.vue?vue&type=script&lang=js&"
export * from "./editServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493beb98",
  null
  
)

export default component.exports